import React, { Component } from 'react';
import Constants from '../../Config/Config';
import {roundToTwo} from '../../Helpers/Helpers';
class Stretching extends Component {

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedLayout !== this.props.selectedLayout || prevProps.frameImageHeight !== this.props.frameImageHeight || prevProps.frameImageWidth !== this.props.frameImageWidth || prevProps.selectedStretching !== this.props.selectedStretching) {
            this.getSelectedStretching();
        }
    }

    getSelectedStretching() {
        const {selectedStretching, frameImageWidth, frameImageHeight, selectedLayout} = this.props;
        if (selectedStretching.size > 0 && selectedLayout.size > 0) {
            const frameWidthNew = parseFloat(frameImageWidth);
            const frameHeightNew = parseFloat(frameImageHeight);
            // Frame Price Calculations
            let selectedLayoutPrice = 0
            if (selectedStretching.getIn(['title', 'rendered']) === 'Stretched') {
                selectedLayoutPrice = selectedLayout.get('stretched_price')
            } else {
                selectedLayoutPrice = selectedLayout.get('un_stretched_price')
            }

            const frameFullDimensionFrame = frameWidthNew + frameHeightNew; // Frame width + height
            if (frameFullDimensionFrame !== 0) {
                let outputFrame = 0;
                if (frameFullDimensionFrame < 105)
                    outputFrame = frameFullDimensionFrame * parseFloat(selectedLayoutPrice);
                else if (frameFullDimensionFrame >= 105 && frameFullDimensionFrame < 140)
                    outputFrame = (frameFullDimensionFrame * 0.16) + (frameFullDimensionFrame * parseFloat(selectedLayoutPrice));
                else if (frameFullDimensionFrame >= 140 && frameFullDimensionFrame < 200)
                    outputFrame = (frameFullDimensionFrame * 0.25) + (frameFullDimensionFrame * parseFloat(selectedLayoutPrice));
                else if (frameFullDimensionFrame >= 200)
                    outputFrame = (frameFullDimensionFrame * 0.33) + (frameFullDimensionFrame * parseFloat(selectedLayoutPrice));

                this.props.dispatch({
                    type: 'SET_STATE',
                    state: {
                        stretchingTotal: outputFrame.toFixed(2),
                        frameSizeH: roundToTwo(frameHeightNew),
                        frameSizeW: roundToTwo(frameWidthNew),
                        frameFullDimension: frameFullDimensionFrame
                    }
                });
            }
        }
    }

	render() {
        const {selectedStretching, stretchingTotal} = this.props;
        return (
            <tr>
                <th>Stretching</th>
                <td>{selectedStretching.size > 0 ? selectedStretching.getIn(['title', 'rendered']) : '-'}</td>
                <td>{Constants.Currency + stretchingTotal}</td>
            </tr>
        );
	}
}

export default Stretching;